import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import { SectionComponent } from '../../../elements/section/section.component';
import { TitleBackgroundComponent } from '../../../elements/title-background/title-background.component';
import {
  Card,
  CardsArray,
  CardsArrayVoyages,
} from '../../../../model/cards';
import {
  DestinationsCountriesComponent
} from '../../destinations-page/items/destinations-countries/destinations-countries.component';
import { Country } from '../../../../model/country';
import { MainBusyBeeComponent } from '../../main/items/main-busy-bee/main-busy-bee.component';
import { MainBestHotelsComponent } from '../../main/items/main-best-hotels/main-best-hotels.component';
import { HeaderService } from '../../../../services/header-service';
import { SectionScrollerComponent } from '../../../elements/section-scroller/section-scroller.component';
import { MainDestinationsComponent } from '../../main/items/main-destinations/main-destinations.component';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Continent } from '../../../../model/circle';
import { AdventuresService } from '../../../../services/adventures-service';
import { LocationDto } from '../../../../model/continent';
import { getLastSegment } from '../../../../functions/getLastSegment';
import { environment } from '../../../../environments/environment';
import { CountryService } from '../../../../services/country-service';
import { FooterService } from '../../../../services/footer-service';
import { NavigationService } from '../../../../services/navigation-service';
import { filter, distinctUntilChanged } from 'rxjs/operators';
import {AdminPreviewComponent} from '../../../elements/admin-preview/admin-preview.component';
import {TokenStorageService} from '../../../../services/token.storage.service';
import {HotelDtoService} from '../../../../services/hotel-dto-service';
import {PaginationParams} from '../../../../model/pagination';
import {NgIf} from '@angular/common';
import {Text} from '../../../../model/text';
import {getFirstSentence} from '../../../../functions/getFirstSentence';
import {MenuService} from '../../../../services/menu-services';
import {LoadingService} from '../../../../services/loading-service';

@Component({
  selector: 'app-adventure-type-page',
  imports: [
    SectionComponent,
    TitleBackgroundComponent,
    DestinationsCountriesComponent,
    MainBusyBeeComponent,
    MainBestHotelsComponent,
    SectionScrollerComponent,
    MainDestinationsComponent,
    AdminPreviewComponent,
    NgIf,
  ],
  templateUrl: './adventure-type-page.component.html',
  standalone: true,
  styleUrl: './adventure-type-page.component.scss'
})
export class AdventureTypePageComponent implements OnInit, AfterViewInit, OnDestroy {
  constructor(protected interfaceService: HeaderService,
              private router: Router,
              private route: ActivatedRoute,
              private adventuresService: AdventuresService,
              protected countryService: CountryService,
              public footerService: FooterService,
              public navigationService: NavigationService,
              protected tokenStorageService: TokenStorageService,
              private hotelService: HotelDtoService,
              protected menuService: MenuService,
              public loadingService: LoadingService,) {}

  continentId: string | null = null

  routeSub: any;
  navigationSub: any;
  loading: boolean = false;
  firstLoading: boolean = true;
  loadingCircle: boolean = false;
  loadingHotel: boolean = true;

  border: boolean = false;

  title: string[] = ['Пляжный туризм', 'Beach tourism'];
  url: string = '';

  adminDisplay: boolean = false;
  uncorrectedUrl: boolean = false;
  displayPageFalse: boolean = false;
  isMobile: boolean = false;

  continents: Continent[] = [];
  countries: Country[] = [];

  busyBeeCard: Card[] = [];
  hotelCards: Card[] = [];

  mainVoyagesTitle: Text[] = [
    {text: ['Путешествуйте  ', 'Discover '],fontFamily: 'pd',fontStyle: 'italic'},
    {text: ['с нами', 'THE WORLD ']},
  ]

  defaultParams = new PaginationParams({
    sort: '',
    query: '',
    pageSize: 50,
    pageNumber: 0,
    adventureId: ''
  });

  locationDto: LocationDto = new LocationDto();

  ngOnInit() {
    if (window.innerWidth <= 570) {
      this.isMobile = true;
      this.menuService.setMobileSpecialStyle(true);
    }
    this.interfaceService.setPageInterface('header-container-white');
    this.interfaceService.setHeaderStyle(true);
    this.routeSub = this.route.paramMap.subscribe(params => {
      const url = getLastSegment(this.router.parseUrl(this.router.url));
      this.getAdventureData(url);
    });
    this.navigationSub = this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        distinctUntilChanged()
      )
      .subscribe(() => {
        const url = getLastSegment(this.router.parseUrl(this.router.url));
        this.getAdventureData(url);
      });
  }

  ngOnDestroy() {
    this.menuService.setMobileSpecialStyle(false);
    this.footerService.setFooterColor('rgba(57, 122, 158, 1)');
    this.footerService.setFooterImage('');
    this.footerService.setFooterStyle('');
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
    if (this.navigationSub) {
      this.navigationSub.unsubscribe();
    }
  }

  getAdventureData(url: string) {
    if (this.url !== url) {
      this.loading = true;
      this.url = url;
      this.resetData();
      this.adventuresService.getAdventureByUrl(url).subscribe((data) => {
        this.locationDto = new LocationDto(data);
        this.locationDto.button = false;
        this.locationDto.destinationsText = [{text: ['Путешествия', 'Adventures']}]
        this.defaultParams.adventureId = this.locationDto.id?.toString()
        if (this.locationDto.url === '') {
          if (this.tokenStorageService.getToken() !== undefined) {
            this.adminDisplay = true;
            this.uncorrectedUrl = true;
          } else {
            this.navigationService.backOrHome();
          }
        }
        if (this.locationDto.displayPage === false) {
          if (this.tokenStorageService.getToken() !== undefined) {
            this.adminDisplay = true;
            this.displayPageFalse = true;
          } else {
            this.navigationService.backOrHome();
          }
        }
        this.footerService.setFooterColor(this.locationDto.footerColor ?? 'rgba(57, 122, 158, 1)');
        this.footerService.setFooterImage(this.locationDto.footerImage ?? '');
        this.footerService.setFooterStyle(this.locationDto.cssStyleFooterImage ?? '');
        this.busyBeeCard = this.locationDto.events.map(v => new Card({
          id: v.id,
          title: [v.titleRu ?? '', v.titleEn ?? ''],
          text: [v.descriptionRu ?? '', v.descriptionEn ?? ''],
          img: environment.s3Prefix + v.image,
          style: v.cssStyle ?? '',
          flex: '',
          tag: v.tag,
          tagRu: v.tagRu,
          button: true,
          anotherButtonText: [{text: ['Связаться', 'Contact us']}],
          link: '/feedback',
          feedValue: [{text: ['Другое', 'Other']}],
        }
        ));
        this.getHotels();
        setTimeout(() => {
          this.loading = false;
        }, 100);
      });
    }
  }

  getHotels() {
    if (this.continentId === null) {
      this.defaultParams.continentId = '';
    } else {
      this.defaultParams.continentId = this.continentId;
    }
    this.hotelService.getHotelList(this.defaultParams).subscribe((data) => {
      this.hotelCards = (data.content ?? []).map(v => {
        const path = v.image ? (environment.s3Prefix + v.image) : '/app/assets/images/hotel.png';
        let link: string | null;
        if (v.city?.country?.continent?.url.length != undefined && v.city?.country?.url != undefined) {
          link = v.city?.country?.continent?.url + '/' + v.city?.country?.url + '/' +
            v.city?.url + '/' + v?.url;
        } else {
          link = null
        }
        let descrRu = '';
        let descrEn = '';
        if (v.descriptionRu !== undefined) {
          descrRu = getFirstSentence(v.descriptionRu);
        }
        if (v.descriptionEn !== undefined) {
          descrEn = getFirstSentence(v.descriptionEn);
        }
        return new Card(
          {
            title: ['', ''],
            text: [v.titleRu, v.titleEn],
            img: path,
            style: v.backgroundStyle?.toString() ?? '',
            button: false,
            link: link,
            rating: v.rating ?? 0,
            anotherButton: true,
            anotherHotelButton: true,
            anotherButtonText: [{text: [descrRu, descrEn]}],
          },
        )
      });
      this.shuffleHotelCards();
      this.loadingHotel = false;
    });
  }

  resetData() {
    this.busyBeeCard = [];
    this.locationDto = new LocationDto();
  }

  getCorrectLocation() {
    if (this.locationDto == null) {
      return new LocationDto(this.countryService.getRandom())
    } else {
      return this.locationDto
    }
  }

  goToDestination(continent: Continent) {
    const url = '/destinations/' + continent.url?.toLowerCase().replaceAll(" ", "-");
    this.router.navigate([url],{relativeTo: this.route}).then(() => {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 0);
    });
  }

  ngAfterViewInit() {
    this.interfaceService.setPageInterface('header-container-white');
  }

  borderEmit(event: boolean) {
    this.border = event;
  }

  shuffleHotelCards(): void {
    for (let i = this.hotelCards.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [this.hotelCards[i], this.hotelCards[j]] = [this.hotelCards[j], this.hotelCards[i]];
    }
  }

  loadingEmit(event: boolean) {
    this.firstLoading = event;
  }

  loadCircle(event: boolean) {
    this.loadingCircle = event
  }

  setContinentId(event: string | null) {
    this.continentId = event;
    if (this.continentId !== null) {
      this.defaultParams.continentId = this.continentId;
      this.getHotels();
    } else {
      this.defaultParams.continentId = '';
      this.getHotels();
    }
  }

  protected readonly CardsArray = CardsArray;
  protected readonly window = window;
  protected readonly CardsArrayVoyages = CardsArrayVoyages;
}
